import type { HelpWidgetMessage } from "../types/help_widget_message";

export const hasUserMessage = (messages: HelpWidgetMessage[]): boolean =>
  messages.some(msg => msg.author_type === "user");

export const hasBotMessage = (messages: HelpWidgetMessage[]): boolean =>
  messages.some(msg => msg.author_type === "bot");

export const shouldShowBotProcessing = (
  messages: HelpWidgetMessage[],
): boolean => hasUserMessage(messages) && !hasBotMessage(messages);

export const getLastMessage = (
  messages: HelpWidgetMessage[],
): HelpWidgetMessage | undefined => messages[messages.length - 1];

export const isExpectingButtonClick = (
  lastMessage: HelpWidgetMessage | undefined,
): boolean => (lastMessage?.buttons?.length ?? 0) > 0;
